export default __webpack_public_path__ + "static/media/define-other-requirements.b5cbc456.svg";